import { defineStore } from 'pinia'
import { useSquadsApi } from '~/services/api'
import type {
  Settings,
  SquadTagColors
} from '~/services/api/modules/squads/types'
import type { CurrentScreen } from '~/components/squads/squadPage/types'

interface SquadsState {
  tagColors: SquadTagColors[] | null
  tagColorsLoading: boolean
  currentScreen: CurrentScreen
  settings: Settings | null
  settingsLoading: boolean
}

export const useSquadsStore = defineStore('squads', {
  state: (): SquadsState => ({
    tagColors: null,
    tagColorsLoading: false,
    currentScreen: 'info',
    settings: null,
    settingsLoading: true
  }),
  actions: {
    async fetchTagColors() {
      if (this.tagColors) {
        return this.tagColors
      }

      const squadsApi = useSquadsApi()
      this.tagColorsLoading = true

      try {
        this.tagColors = await squadsApi.fetchTagColors()
      } finally {
        this.tagColorsLoading = false
      }
    },
    async fetchSettings() {
      if (this.settings) {
        return this.settings
      }

      const squadsApi = useSquadsApi()
      this.settingsLoading = true

      try {
        this.settings = await squadsApi.fetchSquadSettings()
      } finally {
        this.settingsLoading = false
      }
    },
    getHexById(tagColorId: number) {
      if (!this.tagColors) {
        return undefined
      }

      return this.tagColors.find(tagColor => tagColor.id === tagColorId)?.hex
    },
    setCurrentScreen(screen: CurrentScreen) {
      this.currentScreen = screen
    },
    resetCurrentScreen() {
      this.currentScreen = 'info'
    }
  }
})
